<script setup>
import { useFutureStore } from '~/store/future'

defineProps({
  data: {
    type: Object,
    required: true,
  },
  isLink: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()
const future = useFutureStore()
const getText = computed(() => (i) => {
  const { leverage } = future.getPositionConfigByCode(i.code, {}, i.accountName)
  const sideText = i.side === 1 ? t('开多') : t('开空')
  return `${sideText} · ${leverage}X`
})
</script>

<template>
  <NuxtLink :to="isLink ? { params: { symbol: data.code } } : null" class="flex items-center space-x-1 font-medium">
    <span>{{ data.code }}</span>
    <OrdersFuturesBonusTag v-if="data.isBonus" />
    <span>· {{ data.isolated ? t('逐仓') : t('全仓') }}</span>
    <span :class="{ 'text-buy': data.side > 0, 'text-sell': data.side < 0 }">
      · {{ getText(data) }}
    </span>
  </NuxtLink>
</template>
